/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleAdd from './circle-add-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CircleAdd {...validProps} />;
}
SvgComponent.iconName = 'circle-add-icon';

export const CircleAddIcon = svgIconWrapper(SvgComponent);
